import { ReduxStore } from 'store/types';

function getAllIsLoading(state: ReduxStore): boolean {
  return state.intervention.getAll.config.isLoading;
}

export default getAllIsLoading;
